module.exports = __webpack_public_path__ + "img/vail_slide_2.58e94124.jpg";